import { useEffect } from 'react';
import SnowplowCN, {
  newTracker,
  enableActivityTracking,
  enableLinkClickTracking,
  trackPageView,
  trackSelfDescribingEvent,
  // @ts-expect-error: Snowplow types are not defined within the package yet
} from '@condenast/cn-snowplow-web';
import { ConfigService } from '@/services';
import { SiteTrackingPlugin } from '@snowplow/browser-plugin-site-tracking';
import { SubmissionFilters } from '@repo/api/src/open-calls/graphql';

export const spSearchFilter = (
  filters: SubmissionFilters,
  count: number,
  sort: string,
  label: string,
  ids: string[],
  subject?: string,
) => {
  const filter = Object.entries(filters)
    .filter(([k]) => !['openCallId', 'stageId'].includes(k))
    .reduce(
      (acc, data) =>
        Object.keys(data[1] || {}).length === 0
          ? acc
          : [
              ...acc,
              {
                name: data[0],
                label: Array.isArray(data[1])
                  ? data[1].join(',')
                  : String(data[1]),
              },
            ],

      [] as Array<{ name: string; label: string }>,
    );

  trackSelfDescribingEvent({
    event: {
      schema: 'iglu:com.condenast/search_filter_event/jsonschema/4-0-0',
      data: {
        type: 'result',
        label,
        criteria: {
          sort,
          filter,
        },
        // platform: 'talent_tracker',
        subject: subject || 'filter',
        no_of_results_returned: count,
        results_content: [
          { result_type: 'candidates', no_of_results_returned: ids.length },
        ],
      },
    },
  });
};
function appendSnowplowTracker() {
  const collectorURL = ConfigService.SNOWPLOW_CONNECTOR;
  const snowplowConfig = {
    appId: ConfigService.SNOWPLOW_APPID,
    contexts: {
      performanceTiming: true,
      clientHints: true,
      webVitals: true,
    },
    // anonymousTracking: {
    //   withSessionTracking: true,
    //   withServerAnonymisation: true,
    // },
    stateStorageStrategy: 'cookieAndLocalStorage',
    discoverRootDomain: true,
    cookieSameSite: window.location.protocol === 'https:' ? 'None' : 'Lax',
    cookieSecure: window.location.protocol === 'https:',
    // eventMethod: 'post',
    // postPath: '/com.condenast/yv8',
  };
  const anonymousConfig = {};
  const appInfo = {
    appName: 'Vogue Open Calls',
    appId: ConfigService.SNOWPLOW_APPID,
    plugins: [SiteTrackingPlugin()],
  };
  newTracker(collectorURL, { ...snowplowConfig, ...anonymousConfig }, appInfo);
}

let trackerInitialized = false;

// Referenced from Verso: https://github.com/CondeNast/verso/blob/main/src/components/elements/snowplow-script/SnowplowScript.jsx
export const SnowplowScript = () => {
  // Only run client side
  const canLoad =
    typeof window !== 'undefined' &&
    !window.location.search.includes('no_snowplow');

  useEffect(() => {
    if (canLoad && !trackerInitialized) {
      SnowplowCN.injectScript();

      // Initialize tracker only once
      trackerInitialized = true;
      appendSnowplowTracker();

      // Enable tracking features
      // https://github.com/CondeNast/verso/blob/43a828e11a10a61b2203753ea7315ba24f263f6c/src/components/helpers/analytics/snowplow-tracking.js#L744
      enableActivityTracking({
        minimumVisitLength: 5,
        heartbeatDelay: 10,
      });
      enableLinkClickTracking();
      trackPageView();
    }
  }, [canLoad]);

  return null;
};
